import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d62963e")

_pushScopeId("data-v-4d62963e")
const _hoisted_1 = { class: "radio-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_3 = { class: "checkboxtext" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("span", _hoisted_1, [
    _createVNode("input", {
      class: ["inp-cbx2 form-control", { 'inp-cbx2-fw-500': _ctx.fw500OnSelect }],
      name: _ctx.name,
      type: "radio",
      style: {"display":"none"},
      id: _ctx.guid,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
      value: _ctx.value,
      checked: _ctx.checked,
      disabled: _ctx.disabled
    }, null, 10, ["name", "id", "value", "checked", "disabled"]),
    _createVNode("label", {
      class: ["cbx2 mb-0", { 'single-row': _ctx.isSingleRow }],
      for: _ctx.guid,
      tabindex: _ctx.tabIndex
    }, [
      _hoisted_2,
      _createVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ])
      ])
    ], 10, ["for", "tabindex"])
  ]))
})